(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kaze-reviews-cards"] && !Shopify.designMode) return;
  try {
    
  (function(){function initKzrv(root){if(root.dataset.kzrvInit==='true')return;root.dataset.kzrvInit='true';var track=root.querySelector('[data-kzrv-track]');var prev=root.querySelector('[data-kzrv-prev]');var next=root.querySelector('[data-kzrv-next]');if(!track)return;function cardStep(){var card=track.querySelector('.kzrv__card');if(!card)return track.clientWidth;var style=window.getComputedStyle(track);var gap=parseFloat(style.columnGap||style.gap||'16')||16;return card.offsetWidth+gap}function updateNav(){if(!prev||!next)return;var maxScroll=track.scrollWidth-track.clientWidth-1;prev.disabled=track.scrollLeft<=0;next.disabled=track.scrollLeft>=maxScroll}if(prev)prev.addEventListener('click',function(){track.scrollBy({left:-cardStep(),behavior:'smooth'})});if(next)next.addEventListener('click',function(){track.scrollBy({left:cardStep(),behavior:'smooth'})});track.addEventListener('scroll',updateNav,{passive:true});window.addEventListener('resize',updateNav);updateNav();var autoplay=root.dataset.kzrvAutoplay==='true';if(autoplay){var seconds=parseInt(root.dataset.kzrvAutoplaySeconds,10)||5;var timer=null;var paused=false;function tick(){if(paused)return;var maxScroll=track.scrollWidth-track.clientWidth-1;if(track.scrollLeft>=maxScroll){track.scrollTo({left:0,behavior:'smooth'})}else{track.scrollBy({left:cardStep(),behavior:'smooth'})}}function start(){stop();timer=setInterval(tick,seconds*1000)}function stop(){if(timer){clearInterval(timer);timer=null}}['mouseenter','focusin','touchstart','pointerdown'].forEach(function(evt){root.addEventListener(evt,function(){paused=true},{passive:true})});['mouseleave','focusout'].forEach(function(evt){root.addEventListener(evt,function(){paused=false})});start()}}function initAll(){document.querySelectorAll('[data-kzrv]').forEach(initKzrv)}if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',initAll)}else{initAll()}document.addEventListener('shopify:section:load',function(e){var el=e.target.querySelector('[data-kzrv]');if(el)initKzrv(el)})}());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
